import { jsx as _jsx } from "react/jsx-runtime";
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import styled from '../../../components/Theme';
const CopyrightWrapper = styled(FormattedReactMessage).withConfig({
  displayName: "FooterCopyright__CopyrightWrapper",
  componentId: "sc-1oiqq9w-0"
})(["color:", ";"], props => props.theme.colors.OLAF);

const FooterCopyright = () => {
  return /*#__PURE__*/_jsx(CopyrightWrapper, {
    message: "app.footer.copyright",
    options: {
      currentYear: new Date().getFullYear().toString()
    }
  });
};

export default FooterCopyright;